import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class RoleManagementService {

    constructor(
        private authService: AuthService,
        private router: Router,
        private snackBar: MatSnackBar,
        private dialog: MatDialog
    ) { }

    checkUserRole(): Observable<boolean> {
        return this.authService.getCurrentUser().pipe(
            map(user => {
                if (user && user.data.status === 1) {
                    if (user.data.role.status === 1) {
                        return true;
                    } else {
                        this.handleInactiveUser('Your role is Inactive', '/admin/login');
                        return false;
                    }
                } else {
                    this.handleInactiveUser('Your status is Inactive', '/admin/login');
                    return false;
                }
            }),
            catchError(() => {
                this.handleInactiveUser('Error fetching user data', '/admin/login');
                return of(false);
            })
        );
    }

    private handleInactiveUser(title: string, path: string): void {
        this.dialog.closeAll();
        localStorage.clear();
        this.snackBar.open(title, 'Dismiss', {
            duration: 3000
        });
        this.router.navigate([path]);
    }
}
